import styled from 'styled-components';
import { Checkbox } from 'antd';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const Title = styled.h2`
  font-size: 34px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.02em;
  text-align: left;
  color: var(--primary-dark-two);
  margin: 0px 0;
`;

export const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #0a214280;
`;

export const Head = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Div = styled.div``;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
`;

export const SwitchTitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  margin: 0;
`;

export const FormBoxes = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  align-items: center;
  gap: 1rem;

  input[name='ar-title'] {
    direction: rtl;
    text-align: right;
  }
`;

export const CustomCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    border-color: #e8c9bf !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    border-color: #e8c9bf !important;
    background-color: #e8c9bf !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #d18363 !important;
  }

  .ant-checkbox-title {
    font-weight: 600;
  }
`;

export const Button = styled.button`
  background: var(--primary-green);
  border-radius: 10px;
  padding: 12px 55px;
  border: none;
  font-style: normal;
  color: var(--white);
  font-size: 14px;
`;
